import React from "react";
import GlobalLoadingComponent from "./GlobalLoading.component";

const GlobalLoadingContainer = ({ ...props }) => {
    const { message } = props;
    return <GlobalLoadingComponent message={message} />;
};

export default GlobalLoadingContainer;